import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=3f75c01f&"
import script from "./FinalStep.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FinalStep.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports